import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { ContactUpdateInquiriesClosedPage } from "../contactUpdateInquiries/ContactUpdateInquiriesClosedPage";
import { ContactUpdateInquiriesNotYetOpenPage } from "../contactUpdateInquiries/ContactUpdateInquiriesNotYetOpenPage";
import { ContactUpdateInquiryDetails } from "../contactUpdateInquiries/ContactUpdateInquiryDetails";
import { ContactUpdateInquiryProvider } from "../contactUpdateInquiries/ContactUpdateInquiryProvider";
import { PublicContent } from "../PublicContent";
import { ContactUpdateInquiriesDeleteSuccessPage } from "./ContactUpdateInquiriesDeleteSuccessPage";
import { ContactUpdateInquiriesUpdateSuccessPage } from "./ContactUpdateInquiriesUpdateSuccessPage";

export const ContactUpdateInquiriesPage: FC = () => {
	return (
		<Routes>
			<Route element={<PublicContent />}>
				<Route
					path=":id/:contactId"
					element={
						<ContactUpdateInquiryProvider>
							<ContactUpdateInquiryDetails />
						</ContactUpdateInquiryProvider>
					}
				/>
				<Route path="update-success" element={<ContactUpdateInquiriesUpdateSuccessPage />} />
				<Route path="delete-success" element={<ContactUpdateInquiriesDeleteSuccessPage />} />
				<Route path="closed" element={<ContactUpdateInquiriesClosedPage />} />
				<Route path="not-yet-open" element={<ContactUpdateInquiriesNotYetOpenPage />} />
				<Route path="*" element={<NotFound />} />
			</Route>
		</Routes>
	);
};
